module.exports = __webpack_public_path__ + "static/media/turkmenistan-large.5b93c632.jpg";